// extracted by mini-css-extract-plugin
export var text = "_66-0";